<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li><a routerLink="/zorg">Zorg</a></li>
                <li><a routerLink="/onderwijs">Onderwijs</a></li>
                <li class="current_page_item"><a routerLink="/Contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="banner">
    </div>
    <div id="page" class="container">
    <div id="content">
        <div class="title">
            <h2>Auxilium Cu(ltu)ra BV</h2>
        </div>
        <p>
            <b>Hoofdvestiging:</b><br>
            Vliet Noordzijde 46<br>
            2231 GP Rijnsburg<br>
            richard@auxiliumcultura.nl<br>
            
        </p>
        <p>
            <b>Nevenvestiging:</b><br>
            Eksterstraat 19<br>
            2406 VG  Alphen aan den Rijn<br>
            ruud@auxiliumcultura.nl<br>
        </p>
    </div>
    <div id="content">
        <p>
            Website &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; www.auxiliumcultura.nl<br>
            Email &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl  <br>
            Telefoon &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 06 – 53 43 89 00 <br>
            Telefoon &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 06 – 22 50 70 90 <br>
        </p>
        <p>
            Bank &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Rabobank Leiden-Katwijk<br>
            Iban &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NL 03 RABO 0349 6803 45 <br>
            Bic &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; RABONL2U<br>
            KvK &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 76 45 77 53 <br>
            BTW &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 86 06 29 752 <br>
            Betalingen &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Binnen acht (8) dagen na factuurdatum<br>
        </p>
    </div>
</div>
</div>
<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <h2>Contact</h2>
            <p>Auxilium Cu(ltu)ra BV, Vliet Noordzijde 49 2231 GP Rijnsburg</p>
            <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 - 53 43 89 00</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 – 22 50 70 90</p>
        </div>
    </div>
</div>
<div id="copyright-wrapper" class="container">
    <div id="copyright" class="container">
        <p><a routerLink="/copyright">Terms and Conditions</a></p>
    </div>
</div>